import getListValue from './get-list-value';

export default getListValue;
